import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './DiagnosticStyles.css';
import {COL_DEFS, defaultPDFParams, GRID_ENUMS, GridStyle} from "./Styles";
import {AgGridReact} from "ag-grid-react";
import {
    FailCellRenderer,
    PassCellRenderer,
    sortColumns,
    addQuestionColDefs,
    StudentCustomCellRenderer
} from "./Utils";
import TestQuestionResultDialog from "./TestQuestionResultDialog";
import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import {printDocWithColGroups} from "./pdfExport/printDoc";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ClassQuestionViewDiagnosticLegend from "./ClassQuestionViewDiagnosticLegend";
import {UserContext} from "../common/UserContext";

/*
    Version where students are in the first column and questions ant tests are at the top.
 */
const ClassQuestionViewDiagnosticV2 = props => {

    const {
            testAssignmentsData,
            studentTestAssignmentsMap,
            isLoading,
            setLoading,
            students,
            studentIds,
            studentColOrder,
            initialDifficultyIds,
            selectedDifficultyIds,
            selectedTestIds,
            headerHeightOffset,
            openDialogCallback,
            triggerGenerate
        } = props,
        EXTRA_ROW_AMOUNT = 2,
        DIFFICULTY_KEY = '0',
        PERCENT_CORRECT_KEY = '-1',
        PERCENT_ANSWERED_KEY = '-2',
        REPORT_NAME = 'ResultsByQuestion',
        rowHeight = 27,
        defaultColDef = COL_DEFS.defaultColDef,
        studentCustomColDef = {
            cellStyle: {borderRight:'1px solid lightgrey'},
            cellRenderer: StudentCustomCellRenderer,
            width: 150,
            unSortIcon: true,
            field: 'studentName',
            headerName: 'Student name',
            pinned: 'left',
            pinnedOrder: 0,
            sortable:true,
            comparator:(valueA,valueB,nodeA,nodeB,isDescending)=>{
                if(nodeA.data.userId === '0' || nodeA.data.userId === '-1' || nodeA.data.userId === '-2' ||
                    nodeB.data.userId === '0' || nodeB.data.userId === '-1' || nodeB.data.userId === '-2')
                {
                    return 0;
                }
                return valueA.localeCompare(valueB);
            }
        },
        studentColDef = studentCustomColDef,
        totalMarkColDef = COL_DEFS.totalMarkColDef;

    const pinnedLeftCols = [studentColDef],
        // pinnedRightCols = [totalMarkColDef],
        // headerRef = useRef(null),
        gridRef = useRef(),
        [dataMap, setDataMap] = useState({}),
        [testQuestionDialogData, setTestQuestionDialogData] = useState(null),
        [columnDefs, setColumnDefs] = useState([]),
        [graphData, setGraphData] = useState([]),
        [initGraphData, setInitGraphData] = useState([]),
        {user} = useContext(UserContext);

    useEffect(() => {
        if(studentIds.length > 0 && testAssignmentsData.length > 0){
            let updateData = [...initGraphData];
            const resultsMap = {};
            const totalsMap = {};

            testAssignmentsData.forEach((testAssignmentData)=>{
                let count = 0;
                testAssignmentData.testResultBeans.forEach((result)=>{
                    if(studentIds.includes(result.userId)){
                        const totalKey = result.testAssignmentId+'';
                        if(!totalsMap.hasOwnProperty(totalKey)){
                            totalsMap[totalKey]= {};
                        }

                        result.testQuestionResults.forEach((testQuestionResult)=> {
                            const key = result.testAssignmentId + '-' + testQuestionResult.questionId;
                            if(testQuestionResult.mark !== undefined){
                                if (resultsMap.hasOwnProperty(key)) {
                                    resultsMap[key].answered++;
                                    resultsMap[key].total += testQuestionResult.mark;
                                } else {
                                    resultsMap[key] = {answered: 1, total: testQuestionResult.mark, difficulty: testQuestionResult.questionDiffLevel};
                                }
                            }
                        });
                    }
                });
            });

            updateData = updateData.filter((row)=>{
                if(row.userId === PERCENT_ANSWERED_KEY){
                    for(const [key1,value1] of Object.entries(totalsMap)){
                        let addRowScores = 0,
                            answered = 0;
                        for(const [key,value] of Object.entries(row)){
                            if(key !== 'pinned' && key !== 'studentName' && key !== 'userId' && key.split('-')[0] === key1) {
                                row[key] = resultsMap[key] ? Math.round(resultsMap[key].answered / studentIds.length * 100) + '%' : '0%';
                                if(resultsMap[key] && key.split('-')[0] === key1 && (selectedDifficultyIds.length > 0 ? selectedDifficultyIds.includes(resultsMap[key].difficulty) : initialDifficultyIds.includes(resultsMap[key].difficulty))){
                                    addRowScores += resultsMap[key].answered / studentIds.length;
                                    answered++;
                                }
                            }
                        }
                        row[GRID_ENUMS.TEST_TOTAL+key1] = Math.round(addRowScores/answered*100)+'%';
                    }
                    return row;
                }else if(row.userId === PERCENT_CORRECT_KEY){
                    for(const [key1,value1] of Object.entries(totalsMap)) {
                        let addRowScores = 0,
                            answered = 0;
                        for (const [key, value] of Object.entries(row)) {
                            if (key !== 'pinned' && key !== 'studentName' && key !== 'userId' && key.split('-')[0] === key1) {
                                row[key] = resultsMap[key] && !isNaN(Math.round(resultsMap[key].total / resultsMap[key].answered * 100)) ? Math.round(resultsMap[key].total / resultsMap[key].answered * 100) + '%' : '0%';
                                if(resultsMap[key]  && (selectedDifficultyIds.length > 0 ? selectedDifficultyIds.includes(resultsMap[key].difficulty) : initialDifficultyIds.includes(resultsMap[key].difficulty))){
                                    if(!isNaN(resultsMap[key].total / resultsMap[key].answered * 100)){
                                        addRowScores += resultsMap[key].total / resultsMap[key].answered * 100;
                                        answered++;
                                    }

                                }
                            }
                        }
                        row[GRID_ENUMS.TEST_TOTAL+key1] = Math.round(addRowScores/answered)+'%';
                    }
                    return row;
                }else if(row.userId === DIFFICULTY_KEY || studentIds.includes(row.userId)){
                    return row;
                }
            });
            setGraphData(updateData);
        }
    }, [studentIds,initGraphData]);

    const onGridReady = (params) => {
        // showHideUserCols(gridRef,columnDefs,studentIds);
        setLoading(false);
    }

    const doSortData = (data) => {
        return sortColumns(data, studentColOrder);
    }

    useEffect(() => {
        if (selectedTestIds.length === 0 || graphData.length === 0) {
            return;
        }
        setGraphData(doSortData(graphData));
    }, [studentColOrder]);

    const onExportCSV = useCallback(() => {
        gridRef.current.api.exportDataAsCsv({
            fileName: REPORT_NAME,
            processCellCallback: cell => {
                if (cell.column.getUserProvidedColDef().columnType === GRID_ENUMS.USER) {
                    //commented out to change to 1s and 0s
                    // if(String(cell.value).indexOf('%') === -1){
                    //     let val;
                    //     if(cell.value >= 1){
                    // val = '✓';
                    // val = '1';
                    // }else if(cell.value === 0){
                    // val = '✗';
                    // val = '0';
                    // }
                        // cell.value = val;
                    // }
                }else if(cell.column.colId === GRID_ENUMS.CORRECT_PERCENT){
                    if(cell.value === GRID_ENUMS.NOT_AVAILABLE){
                        cell.value = '';
                    }
                }
                return cell.value;
            }
        });
    }, []);

    const onExportPDF = useCallback(() => {
        printDocWithColGroups(defaultPDFParams,gridRef.current.api,REPORT_NAME,2);
    }, []);

    const getQuestionMapObj = (testAssignmentResult) =>{

        const questionsData = testAssignmentResult.testQuestionBeans;
        let questionMapObj = {};
        questionsData.forEach(question => {
            questionMapObj[testAssignmentResult.testAssignmentId+'-'+question.questionId] = '';
        });
        return questionMapObj;
    }

    const getRowExtraQuestionObjs = (testAssignmentResult) =>{

        let extraRowsMap = {};
        const questionsData = testAssignmentResult.testQuestionBeans;
        let difficultyMapObj = {},
            percentCorrectMap = {},
            percentAnsweredMap = {};
        questionsData.forEach(question => {
            difficultyMapObj[testAssignmentResult.testAssignmentId+'-'+question.questionId] = question.testDiffLevel;
            percentCorrectMap[testAssignmentResult.testAssignmentId+'-'+question.questionId] = '0%';
            percentAnsweredMap[testAssignmentResult.testAssignmentId+'-'+question.questionId] = '0%';
        });
        extraRowsMap.difficultyMap = difficultyMapObj;
        extraRowsMap.percentCorrectMap = percentCorrectMap;
        extraRowsMap.percentAnsweredMap = percentAnsweredMap;
        return extraRowsMap;
    }

    useEffect(() => {
        if (selectedTestIds.length === 0 || Object.keys(dataMap).length === 0) {
            return;
        }
        setGraphData(doSortData(Object.values(dataMap)));
        setInitGraphData(Object.values(dataMap));
    }, [dataMap]);

    const mapStudentDataToQuestionObjs = (testAssignmentData, studentMap) => {
        const questionObjMap = getQuestionMapObj(testAssignmentData),
            extras = getRowExtraQuestionObjs(testAssignmentData),
            difficultyQuestionObjMap = extras.difficultyMap,
            percentCorrectMap = extras.percentCorrectMap,
            percentAnsweredMap = extras.percentAnsweredMap;
        for(const [key,value] of Object.entries({...studentMap})){
            if(key === PERCENT_CORRECT_KEY){
                studentMap[key] = {...studentMap[key], ...percentCorrectMap};
            }else if(key === PERCENT_ANSWERED_KEY){
                studentMap[key] = {...studentMap[key], ...percentAnsweredMap};
            }else if(key === DIFFICULTY_KEY){
                studentMap[key] = {...studentMap[key], ...difficultyQuestionObjMap};
            }else{
                studentMap[key] = {...studentMap[key], ...questionObjMap};
            }
        }
    }

    useEffect(() => {
        if (selectedTestIds === undefined || selectedTestIds.length === 0 || testAssignmentsData.length === 0 || students.length === 0) {
            return;
        }
        setGraphData([]);

        mapColumnDefs(selectedDifficultyIds);
        let studentMap = {},
            difficultyRow = {},
            totalCorrectRow = {},
            totalPercentRow = {};

        difficultyRow[GRID_ENUMS.CORRECT_PERCENT] = GRID_ENUMS.NOT_AVAILABLE;
        difficultyRow[GRID_ENUMS.CORRECT_PERCENT_VALUE] = -1;
        difficultyRow.total = false;
        difficultyRow.pinned = 'left';
        difficultyRow[GRID_ENUMS.ALL_ANSWERED_PERCENT] = '';
        difficultyRow[GRID_ENUMS.ALL_ANSWERED_PERCENT_VALUE] = -1;
        difficultyRow[studentColDef.field] = 'DIFFICULTY';
        difficultyRow['userId'] = DIFFICULTY_KEY;

        totalCorrectRow.pinned = 'right';
        totalCorrectRow[studentColDef.field] = '% CORRECT';
        totalCorrectRow['userId'] = PERCENT_CORRECT_KEY;

        totalPercentRow.pinned = 'right';
        totalPercentRow[studentColDef.field] = '% of ALL ANSWERED';
        totalPercentRow['userId'] = PERCENT_ANSWERED_KEY;

        studentMap[DIFFICULTY_KEY] = difficultyRow;
        studentMap[PERCENT_CORRECT_KEY] = totalCorrectRow;
        studentMap[PERCENT_ANSWERED_KEY] = totalPercentRow;

        students.forEach((student) => {
            let row = {
                userId:student.userId
            };

            row[GRID_ENUMS.CORRECT_PERCENT] = GRID_ENUMS.NOT_AVAILABLE;
            row[GRID_ENUMS.CORRECT_PERCENT_VALUE] = -1;
            row.total = false;
            row[GRID_ENUMS.ALL_ANSWERED_PERCENT] = '';
            row[GRID_ENUMS.ALL_ANSWERED_PERCENT_VALUE] = -1;

            row[studentColDef.field] = student.lastName+', '+student.firstName;
            row['firstName'] = student.firstName;
            row['lastName'] = student.lastName;
            studentMap[student.userId] = row;
        });
        testAssignmentsData.forEach((testAssignmentData) => {
            mapStudentDataToQuestionObjs(testAssignmentData, studentMap);
        });

        testAssignmentsData.forEach((testAssignmentData) => {
            mapTestResultsToStudents(testAssignmentData, studentMap, students.length);
        });
        if (Object.entries(studentMap).length > 0) {
            setDataMap(studentMap);
            // setInitStudentMap(studentMap);
        } else {
            setLoading(false);
        }
        setLoading(false);
    }, [triggerGenerate, selectedDifficultyIds]);

    const mapTestResultsToStudents = (testAssignmentData, studentMap, studentAmount)=>{
        const percentTotalTracker = {};
        testAssignmentData.testResultBeans.forEach((result)=> {
            if(studentMap.hasOwnProperty(result.userId)){
                studentMap[result.userId]['answered'] = false;
                studentMap[result.userId]['columnType'] = 'user';
                studentMap[result.userId]['userId'] = result.userId;
                studentMap[result.userId]['studentName'] = result.lastName + ', ' + result.firstName;
                studentMap[result.userId]['callback'] = openDialogCallback;
                if (result.totalAnswered > 0) {
                    let testTotalVal = result.percentCorrect;
                    if (selectedDifficultyIds.length === 1) {
                        testTotalVal = result['markPercentLevel' + selectedDifficultyIds[0]];
                        studentMap[result.userId][GRID_ENUMS.TEST_TOTAL + result.testAssignmentId] = testTotalVal + '%';
                    } else if (selectedDifficultyIds.length > 1 && selectedDifficultyIds.length < initialDifficultyIds.length) {
                        let totalMark = 0,
                            totalMaxMark = 0;
                        selectedDifficultyIds.forEach((level) => {
                            totalMark += result['markLevel' + level];
                            totalMaxMark += result['maxMarkLevel' + level];
                        });
                        if (totalMark > 0 && totalMaxMark > 0) {
                            testTotalVal = Math.round(totalMark / totalMaxMark * 100);
                        } else {
                            testTotalVal = 0;
                        }
                        studentMap[result.userId][GRID_ENUMS.TEST_TOTAL + result.testAssignmentId] = testTotalVal + '%';
                    } else {
                        studentMap[result.userId][GRID_ENUMS.TEST_TOTAL + result.testAssignmentId] = testTotalVal + '%';
                    }
                    if (studentMap[result.userId].hasOwnProperty(GRID_ENUMS.TEST_TOTAL_VALUE)) {
                        studentMap[result.userId][GRID_ENUMS.TEST_TOTAL_VALUE] += testTotalVal;
                        studentMap[result.userId][GRID_ENUMS.TEST_AMOUNT]++;
                    } else {
                        studentMap[result.userId][GRID_ENUMS.TEST_TOTAL_VALUE] = testTotalVal;
                        studentMap[result.userId][GRID_ENUMS.TEST_AMOUNT] = 1;
                        studentMap[result.userId]['answered'] = true;
                    }
                    studentMap[result.userId][GRID_ENUMS.PERFORMANCE] = Math.round(studentMap[result.userId][GRID_ENUMS.TEST_TOTAL_VALUE] / studentMap[result.userId][GRID_ENUMS.TEST_AMOUNT]);
                    // if(!percentTotalTracker.hasOwnProperty(result.testAssignmentId+'')){
                    // //     studentMap[PERCENT_CORRECT_KEY][GRID_ENUMS.TEST_TOTAL+result.testAssignmentId] = 0;
                    //     percentTotalTracker[result.testAssignmentId+''] = {percentTotal:0, percentCount:0}
                    // }
                    // percentTotalTracker[result.testAssignmentId+''].percentTotal += result.percentCorrect;
                    // percentTotalTracker[result.testAssignmentId+''].percentCount++;
                    // // studentMap[PERCENT_CORRECT_KEY][GRID_ENUMS.TEST_TOTAL+result.testAssignmentId] = Math.round(percentTotalTracker[result.testAssignmentId+''].percentTotal/percentTotalTracker[result.testAssignmentId+''].percentCount);
                    // console.log('Math.round(percentTotalTracker[result.testAssignmentId+\'\'].percentTotal/percentTotalTracker[result.testAssignmentId+\'\'].percentCount): ',Math.round(percentTotalTracker[result.testAssignmentId+''].percentTotal/percentTotalTracker[result.testAssignmentId+''].percentCount));
                    // studentMap[PERCENT_CORRECT_KEY].totalPercentCorrect = Math.round(percentTotalTracker[result.testAssignmentId+''].percentTotal/percentTotalTracker[result.testAssignmentId+''].percentCount);

                }
                const resultsMap = {};
                result.testQuestionResults.forEach((testQuestionResult)=> {
                    if (selectedDifficultyIds.length === 0 || selectedDifficultyIds.includes(testQuestionResult.questionDiffLevel)) {
                        const key = result.testAssignmentId + '-' + testQuestionResult.questionId;
                        if(testQuestionResult.skipped){
                            studentMap[result.userId][key] = 'skipped';
                        } else {
                            if (resultsMap.hasOwnProperty(key)) {
                                resultsMap[key].answered++;
                                resultsMap[key].total += testQuestionResult.mark;
                            } else {
                                resultsMap[key] = {answered: 1, total: testQuestionResult.mark};
                            }
                            studentMap[result.userId][key] = testQuestionResult.mark;
                            studentMap[PERCENT_CORRECT_KEY][key] = 50;
                        }
                    }

                });
            }
        })
    }

    const mapColumnDefs = (difficultyLevels)=>{
        const columnDefsArr = [...pinnedLeftCols];
        testAssignmentsData.forEach((data)=>{
            const questionColDef = {questions: data.testQuestionBeans, columnArr: columnDefsArr,
             testAssignmentId:data.testAssignmentId, testAssignmentName: data.testAssignmentName,
                difficultyLevels:difficultyLevels, testId:data.testId, authorName:data.lastName+', '+data.firstName,
                assignedDate: user.dateTimeMinuteFormat.format(data.assignedDate),
                classes:data.classes
            };
            addQuestionColDefs(questionColDef);
        });
        setColumnDefs(columnDefsArr);
    }

    const handleCellClick = (cell) => {
        if(cell.colDef.columnType !== GRID_ENUMS.QUESTION || cell.value === undefined || cell.value === ''){
            return;
        }
        const {testAssignmentId, testId, questionId, title} = cell.colDef.headerComponentParams,
            {userId, studentName} = cell.data;

        let testAssignId = testAssignmentId;
        if (questionId !== undefined) {
            if (testAssignId === undefined) {
                if (studentTestAssignmentsMap[userId]) {
                    testAssignId = studentTestAssignmentsMap[userId][testId].get(0);
                }
            }
            if (parseInt(userId) > 0 && testAssignId !== undefined) {
                setTestQuestionDialogData({
                    testAssignmentId: testAssignId,
                    questionId: questionId,
                    userId: userId,
                    title: title,
                    studentName: studentName,
                })
            }
        }
    }

    const postSortRows = params=> {
        let rowNodes = params.nodes;
        if (rowNodes.length === 0) {
            return;
        }
        //put pinned rows at the bottom after sorting
        for (let i = rowNodes.length - 1; i >= 0; i--) {
            if (rowNodes[i].data && rowNodes[i].data.userId === '-1') {
                rowNodes.splice(rowNodes.length - 1, 0, rowNodes.splice(i, 1)[0]);
                break;
            }
        }
        for (let i = rowNodes.length - 1; i >= 0; i--) {
            if (rowNodes[i].data && rowNodes[i].data.userId === '-2') {
                rowNodes.splice(rowNodes.length - 1, 0, rowNodes.splice(i, 1)[0]);
                break;
            }
        }
        //put pinned rows at start after sorting
        for (let i = rowNodes.length - 1; i >= 0; i--) {
            if (rowNodes[i].data && rowNodes[i].data.userId === '0') {
                rowNodes.splice(0, 0, rowNodes.splice(i, 1)[0]);
            }
        }
    }

    const getToolBar = () => (
        <>
            <div>

            </div>
            <div className="export-toolbar genBtn-blk">
                <button type="button" className="btn btn-default excel genBtn smallBtn"
                        onClick={onExportCSV}
                >Export CSV <FileDownloadIcon/>
                </button>
                <button type="button" className="btn btn-default reset genBtn smallBtn"
                        onClick={onExportPDF}
                >Export PDF <FileDownloadIcon/>
                </button>
            </div>
        </>
    );

    return(
        <div>
            <ClassQuestionViewDiagnosticLegend/>
            {!isLoading && graphData && graphData.length > 0 && getToolBar() }
                <div className="ag-grid-wrapper">
                    <div id={"classQuestionView"} className="ag-theme-balham"
                         style={{
                             height: (Math.ceil(rowHeight/2)+rowHeight*EXTRA_ROW_AMOUNT+rowHeight * graphData.length + GridStyle.QUESTIONS_HEADER_HEIGHT + GridStyle.GRID_PADDING_SML + GridStyle.HORIZONTAL_SCROLLBAR_PADDING - Math.abs(headerHeightOffset))+'px',
                             marginTop: Math.abs(headerHeightOffset)+'px'
                         }}>
                        <AgGridReact
                            className="ch-general-table-ag-grid rounded-top"
                            ref={gridRef}
                            suppressPropertyNamesCheck={true}
                            suppressHorizontalScroll={true}
                            suppressRowTransform={true}
                            headerHeight={GridStyle.QUESTIONS_HEADER_HEIGHT}
                            columnDefs={columnDefs}
                            rowData={graphData}
                            defaultColDef={defaultColDef}
                            rowHeight={rowHeight}
                            onGridReady={onGridReady}
                            onCellClicked={handleCellClick}
                            postSortRows={postSortRows}
                            components={{
                                passCellRenderer: PassCellRenderer,
                                failCellRenderer: FailCellRenderer
                            }}
                        />
                    </div>
                </div>
            {/*}*/}
            <TestQuestionResultDialog data={testQuestionDialogData} setData={setTestQuestionDialogData} />
        </div>
    )
}

export default ClassQuestionViewDiagnosticV2;
